<template>
  <div class="bg-white border_radius_10 p-3 mb-3">
    <b-row v-if="file" class="text-left mx-0 mb-1">
      <b-col cols="auto" md="auto" class="px-0 position-relative">
        <span
          class="close__image text-danger bg-white rounded-circle"
          @click="remove"
        >
          <mdicon name="close-circle" size="20" />
        </span>
        <b-img
          :src="getImg"
          thumbnail
          rounded
          class="square_image bg-white"
          :class="
            attachmentTypeId === 10
              ? 'object__fit--cover'
              : 'object__fit--contain'
          "
        />
      </b-col>
    </b-row>
    <!-- uploader_style--success --error -->
    <b-row class="uploader_style mb-3" :class="stateClass">
      <b-col cols="12" md="12" class="center mb-2">
        <label for="file" class="uploader_style__progress_bar w-100">
          <span class="uploader_style__state_text" v-text="stateText" />
          <div
            class="uploader_style__background_progress_bar"
            :style="`width: calc(${progressWidth}% - 30px)`"
          />
        </label>
        <div class="uploader_style__remove_button" @click="remove">
          <mdicon name="sim-off-outline" size="30" />
        </div>
        <input
          type="file"
          name="file"
          id="file"
          ref="file"
          @change="onChange"
        />
      </b-col>
      <b-col cols="12" md="12">
        <div
          class="uploader_style__validation_text"
          v-text="errorMessage || generateValidationText()"
        />
      </b-col>
    </b-row>
    <CropFile
      ref="cropComponent"
      :file="file"
      :aspectRatio="aspectRatio"
      :initialAspectRatio="aspectRatio"
      @clearValue="remove"
      @save="createFile"
    />
  </div>
</template>

<script>
import CropFile from "../fileManager/cropFile";
import { generateApiUrl } from "@/shared/utils";
import { pathOr } from "ramda";

export default {
  name: "single-upload",
  components: {
    CropFile,
  },
  props: {
    url: {
      type: String,
      default: null,
    },
    id: {
      type: [String, Number],
      default: null,
    },
    caption: {
      type: String,
      default: "",
    },
    attachmentTypeId: {
      type: [Array, Number],
      default: null,
    },
    attachmentTypeName: {
      type: String,
      default: "",
    },
    acceptFormats: {
      type: Array,
      default: () => [
        {
          caption: "عکس",
          value: "10MB",
          suffix: ["png", "jpg", "jpeg"],
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
          suffix: ["pdf", "xls", "xlsx", "doc", "docx", "ppt", "pptx"],
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
          suffix: ["mp3", "mp4", "wmv"],
        },
      ],
    },
    hasCrop: {
      type: Boolean,
      default: true,
    },
    aspectRatio: {
      type: Number,
      default: null,
    },
    maxUploadFile: {
      type: Number,
      default: 10485760,
    },
    fileCaption: {
      type: String,
      default: "فایل",
    },
  },
  data() {
    return {
      stateText: `بارگذاری ${this.fileCaption}`,
      errorMessage: "",
      progressWidth: 0,
      stateClass: "",
      file: null,
      fileSelected: null,
    };
  },
  computed: {
    getImg() {
      if (!this.file) return;
      const fileType = this.file.type;
      const fileName = this.file.name.split(".").pop(); // get file by suffix name
      return fileType.match("image")
        ? URL.createObjectURL(this.file)
        : `/img/shared/file-icon/${fileName}.svg`;
    },
  },
  watch: {
    id(value) {
      value && this.upload(this.file);
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    generateValidationText() {
      return (
        "فایل‌های مجاز: " +
        this.acceptFormats
          .map((item) => {
            return `${item.caption} (${item.value.replace("MB", " مگابایت")})`;
          })
          .join("، ")
          .toString()
      );
    },
    checkValidFile(file, acceptData) {
      if (!file) return;
      const suffix = file.name.split(".").pop();
      const { size } = file;
      return acceptData.some((acceptItem) => {
        const acceptItemSize = +acceptItem.value.replace("MB", "") * 1048576;
        const checkSize = acceptItemSize >= size;
        const checkSuffix = acceptItem.suffix.length
          ? acceptItem.suffix.includes(suffix)
          : true;
        return checkSize && checkSuffix;
      });
    },
    getFileValidate(file, acceptData) {
      if (!file) return;
      const suffix = file.name.split(".").pop();
      const { size } = file;
      return acceptData.find((acceptItem) => {
        const acceptItemSize = +acceptItem.value.replace("MB", "") * 1048576;
        const checkSize = acceptItemSize >= size;
        const checkSuffix = acceptItem.suffix.length
          ? acceptItem.suffix.includes(suffix)
          : true;
        return checkSize && checkSuffix;
      });
    },
    generateStateText() {
      const size = this.bytesToSize(this.file.size);
      const fileValidate = this.getFileValidate(this.file, this.acceptFormats);
      const fileCaption = pathOr("فایل غیرمجاز", ["caption"], fileValidate);
      this.stateText = `${fileCaption} (${size})`;
    },
    async onChange(e) {
      this.reset();
      this.file = e.target.files[0];
      const isValid = this.checkValidFile(this.file, this.acceptFormats);
      this.generateStateText();
      if (!isValid) {
        this.errorMessage = this.generateValidationText();
        this.stateClass = "uploader_style--error";
        this.$emit("hasFile", false);
        return;
      }
      this.stateClass = "uploader_style--success";
      if (this.hasCrop && this.isImage(this.file)) {
        this.$refs.cropComponent.view_crop = true;
        return;
      }
      this.$emit("hasFile", true);
    },
    remove() {
      this.reset();
      this.$refs.file.value = null;
    },
    reset() {
      this.file = null;
      this.stateClass = "";
      this.errorMessage = "";
      this.stateText = `بارگذاری ${this.fileCaption}`;
      this.progressWidth = 0;
      this.$refs.cropComponent.value = null;
    },
    bytesToSize(bytes) {
      const sizes = ["بایت", "کیلوبایت", "مگابایت", "گیگابایت"];
      if (bytes === 0) return "0 بایت";
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
    async upload(file) {
      if (!file) return;

      try {
        this.stateClass = "";
        const headers = {
          "Content-Type": "multipart/form-data",
        };
        const progressing = {
          onUploadProgress: function (e) {
            this.progressWidth = parseInt(
              Math.round((e.loaded * 100) / e.total)
            );
            this.stateText = `در حال بارگذاری ${this.fileCaption} ${this.progressWidth}%`;
          }.bind(this),
        };
        const formData = new FormData();
        formData.append("file", file);
        formData.append("caption", this.caption);
        formData.append("attachment_type_id", this.attachmentTypeId);
        formData.append("attachment_type_name", this.attachmentTypeName);
        await this.$httpService.post(
          this.url,
          formData,
          headers,
          true,
          progressing
        );
        this.stateClass = "uploader_style--success";
        this.stateText = "بارگذاری با موفقیت انجام شد";
        this.$emit("success", true);
      } catch (error) {
        this.stateClass = "uploader_style--error";
        this.stateText = `بارگذاری ${this.fileCaption}`;
        this.errorMessage = pathOr("", ["response", "data", "message"], error);
        this.$emit("success", false);
      } finally {
        this.progressWidth = 0;
      }
    },
    async createFile(files) {
      const file = pathOr(files, ["0"], files);
      const imageFile = pathOr(null, ["img"], file);
      this.file = this.hasCrop && this.isImage(file) ? imageFile : file;
      this.generateStateText();
      this.$emit("hasFile", true);
    },
    isImage(file) {
      const imageFile = pathOr(file, ["img"], file);
      return imageFile
        ? ["png", "jpg", "jpeg"].some((item) => imageFile.type.match(item))
        : false;
    },
  },
};
</script>
<style lang="scss" scoped>
.close__image {
  position: absolute;
  top: 1px;
  left: 1px;
  cursor: pointer;
}
</style>
